export default __webpack_public_path__ + "static/MaisTempo-image-52564b2cba24cf05d5155ea7afca95f2.png";